import { render, staticRenderFns } from "./BasicRadio.vue?vue&type=template&id=856ea646&"
import script from "./BasicRadio.vue?vue&type=script&lang=js&"
export * from "./BasicRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports